import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../common/Button";
import { useState } from "react";
import { completeTransferRequest } from "../../lib/fetchApi";
import { notificationActions } from "../../store/notifications";
import { transfersActions } from "../../store/transfers";
import Backdrop from "../common/modal/Backdrop";
import Modal from "../common/Modal";
import ModalInnerWrapper from "../common/ModalInnerWrapper";
import PannelBody from "../fragments/PannelBody";
import { getLocationNameFromId } from "../../lib/labels";

export default function CompleteTransfer({caseID, transferData}) {
    const dispatch = useDispatch()
    const [loading, isLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const userToken = useSelector(state => state.user.token)

    function openModalHandler() {
        setShowModal(prevState => !prevState)
    }

    function closeModalHandler() {
        setShowModal(false)
    }

    async function completeTransferHandler() {
        isLoading(true)

        let reqBody = {
            case_practice_id: transferData?.case_practice_id,
            case_practice_transfer_id: transferData?.id
        }

        let completeTransfer = await completeTransferRequest(userToken, caseID, reqBody)
        if (completeTransfer && completeTransfer.errorMessage) {
            dispatch(notificationActions.setError(completeTransfer))
        } else {
            dispatch(notificationActions.setError({errorMessage: `Transfer Completed!`, type: 'success'}))
            dispatch(transfersActions.setRefreshApi())
            closeModalHandler()
        }

        isLoading(false)
    }

    return <>
        <Button btnStyle={'btn_small'} click={openModalHandler} >
            Complete
        </Button>

        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler}  modalTitle={'Complete Transfer'}>
                        <PannelBody>
                            <p>This will mark the transfer as completed. The patient will remain at {getLocationNameFromId(transferData?.to_location_id)}.</p>
                        </PannelBody>
                        <PannelBody>
                            <div className="flex-container">
                                <Button click={completeTransferHandler} isLoading={loading}>Ok</Button>
                            </div>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}

        </>}
    </>
}
